import React from "react";
import { Box } from "@chakra-ui/react";
import Header from "./Header";
import Body from "./Body";
import Footer from "./Footer";
const Integration = () => {
  return (
    <React.Fragment>
      <Box
        bg="#FFFFFF"
        borderRadius="4px"
        m="2rem auto"
        p="32px"
        w="680px"
        h="192px"
        color="#12344D"
      >
        {/* header */}
        <Header />
        {/* body */}
        <Body />
      </Box>
      <Box
        bg="#FFFFFF"
        borderRadius="4px"
        m="2rem auto"
        p="32px"
        w="680px"
        minH="416px"
        color="#12344D"
      >
        <Footer />
      </Box>
    </React.Fragment>
  );
};

export default Integration;
